<template>
    <div class="form-group" @keydown.enter.prevent.self>
        <label v-if="label" :for="name" class="form-label">{{ label }}
            <span v-if="required" class="text-black astric"> *</span>
        </label>
        
        <div class="select-with-style">
            <el-select
                :id="name"
                ref="selectRef" v-model="vModel" :clearable="clearable" :disabled="disabled" :fit-input-width="true" :multiple="multiple"
                :name="name" :no-data-text="$t(`messages.no_data`)" :no-match-text="$t(`messages.no_data`)" :placeholder="computedPlaceholder" :popper-options="{ strategy: 'fixed' }"
                :remote="remote"
                :remote-method="onSearch"
                :reserve-keyword="false"
                :teleported="teleported"
              
                placement="bottom"
                
                class="d-block w-100" filterable
                size="large"
                @change="onChange" @input="onChange" @select="onSelect">
                <el-option v-if="actionOptionEnabled && !multiple" :key="'__action__'" :label="actionOptionLabel" :value="actionOptionValue">
                    <span>{{ actionOptionLabel }}</span>
                </el-option>
                <el-option v-for="item in _options" :key="item.id" :label="item.name" :value="item.id">
                    <span class="option-item">
                        <span v-if="showOptionAvatar && item[optionAvatarField]" class="option-avatar">
                            <img :alt="item.name" :src="item[optionAvatarField]" :style="{ width: avatarSize + 'px', height: avatarSize + 'px' }"/>
                        </span>
                        <span class="option-text">{{ item.name }}</span>
                    </span>
                </el-option>
            </el-select>
        </div>
        <small
            v-if="errors && errors[error_name || name]" class="form-text text-danger"
            v-text="errors[error_name || name][0]"/>
    </div>
</template>

<script>

import i18n from "@/lang";

const {t} = i18n.global;
export default {
    emits: ['action', 'change', 'keyup'],
    props: {
        label: {
            type: String
        },
        teleported: {
            type: Boolean,
            default: true
        },

        name: {
            type: String,
            required: true
        },

        model: {
            type: [Object, Array],
            required: true
        },

        errors: {
            type: [Object, Array],
            // required: true
        },

        options: {
            type: [Array],
            required: true
        },

        labelField: {
            type: String,
            required: false,
            default: "label"
        },

        valueField: {
            type: String,
            default: "id"
        },

        multiple: {
            type: Boolean
        },

        disabled: {
            type: Boolean
        },

        error_name: {
            type: String,
        },

        required: {
            type: Boolean,
        },
        reduce: {
            type: Function,
            default: (value) => value,
        },
        selectAllOption: {
            type: Boolean,
            default: false
        },
        remote: {
            type: Boolean,
            required: false
        },
        clearable: {
            type: Boolean,
            required: true
        },
        placeholder: {
            type: String,
        }
        ,
        // Optional first option as an action button (e.g., Add New Client)
        actionOptionEnabled: {
            type: Boolean,
            default: false
        },
        actionOptionLabel: {
            type: String,
            default: ''
        },
        actionOptionValue: {
            type: [String, Number],
            default: -9999
        },
        showOptionAvatar: {
            type: Boolean,
            default: false
        },
        optionAvatarField: {
            type: String,
            default: 'avatar'
        },
        avatarSize: {
            type: Number,
            default: 20
        }

    },

    computed: {
        computedPlaceholder() {
            return this.placeholder
                ? this.placeholder
                : `${t('messages.select')} ${this.label || t('option')}`;
        },
        vModel: {
            get: function () {
                // Retrieve the raw value from the model
                const raw = _.get(this.model, this.name);

                // For multiple selects, Element Plus expects an array always
                if (this.multiple) {
                    if (Array.isArray(raw)) {
                        return raw;
                    }
                    // Gracefully coerce primitives or undefined to an empty array
                    return [];
                }

                // Single select coercions
                if (this.name === 'charge_code') {
                    return raw !== undefined ? parseInt(raw) : ''
                }
                if (this.name === 'business_unit_id') {
                    return raw !== undefined ? parseInt(raw) : 1
                }

                return raw

                /* if (this.name.indexOf('[]') > -1 && (_.get(this.model, this.name) !== undefined || _.get(this.model, this.name) != null)) {
                    return Object.values(_.get(this.model, this.name));
                } else {
                    console.log(this.name, _.get(this.model, this.name))
                    if (this.name === 'charge_code') {
                        return parseInt(_.get(this.model, this.name))
                    }
                    return _.get(this.model, this.name)
                } */

            },
            // setter
            set: function (newValue) {
                // If the special action option is chosen, trigger action and do not persist value
                if (!this.multiple && this.actionOptionEnabled && newValue === this.actionOptionValue) {
                    this.$emit('action');
                    return;
                }
                if (this.multiple) {
                    // Ensure we always set an array for multiple
                    const safeArray = Array.isArray(newValue) ? newValue : [];
                    _.set(this.model, this.name, safeArray);
                    return;
                }
                _.set(this.model, this.name, newValue);
            }
        },
        _options() {
            // Check if component is multiple, hence prepend select all option
            if (this.multiple && !_.isEmpty(this.options) && this.selectAllOption) {

                if (!this.haveAllOption()) {
                    this.options.unshift({id: -1, [`${this.labelField}`]: t("select_all")});
                }
            }
            return this.options;
        },
    },

    watch: {
        //  options(newVal, oldVal) {
        //     let newIDs = newVal.map(item => item.id);
        //     let currentModel = _.get(this.model, this.name);
        //
        //     // Check if model is array
        //     if (Array.isArray(currentModel)) {
        //         // filter model
        //         let newModel = currentModel.filter(function (el) {
        //             return newIDs.includes(el.id);
        //         });
        //         _.set(this.model, this.name, newModel);
        //     }
        // }
    },

    methods: {
        onSelect(value) {
            // Immediate intercept on selecting the action option from dropdown
            if (this.actionOptionEnabled && value === this.actionOptionValue) {
                this.$emit('action');
                // Close dropdown and clear highlighted option without changing the v-model
                this.$refs.selectRef && this.$refs.selectRef.blur();
                return;
            }
            this.onChange(value);
        },
        onChange(value) {
            // Intercept action option selection
            if (this.actionOptionEnabled && value === this.actionOptionValue) {
                this.$emit('action');
                // reset the select to previous value to avoid persisting the action sentinel
                this.$nextTick(() => {
                    this.$emit('change', this.vModel);
                });
                return;
            }
            this.$emit('change', value);
            this.$emit('keyup');
        },
        onSearch(value) {
            if (this.remote) {
                // if (value.length < 2) {
                //     return false;
                // }
                this.$emit("searchServerSide", value);
            }
        },
        haveAllOption() {
            this.options.forEach(item => {
                return item.id === -1;
            });
        }
    }
};
</script>

<style scoped>
.select-with-style {
    position: relative;
}

/* Shared border/radius */
:deep(.el-select .el-input__wrapper) {
    border-radius: 12px;
    box-shadow: inset 0 0 0 1px #E2E8F0;
}

/* Single select fixed height */
:deep(.el-select:not(.is-multiple) .el-input__wrapper) {
    height: 48px;
}

/* Multiple select: allow growth but keep a good minimum height */
:deep(.el-select.is-multiple .el-input__wrapper) {
    height: auto;
    min-height: 48px;
    padding: 8px 12px;
}

/* Focus ring to match the new design (soft purple) */
:deep(.el-select .el-input.is-focus .el-input__wrapper),
:deep(.el-select .el-input__wrapper.is-focus) {
    box-shadow: inset 0 0 0 2px #9b8cff, 0 0 0 3px rgba(155, 140, 255, 0.25);
}

/* Multiple select tags style */
/* Tags wrap and scroll when many selected */
:deep(.el-select .el-select__tags) {
    margin: 0;
    flex-wrap: wrap;
    gap: 4px;
}

:deep(.el-select.is-multiple .el-select__tags) {
    max-height: 120px;
    overflow-y: auto;
    /* Clean scrollbar styling */
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

:deep(.el-select.is-multiple .el-select__tags::-webkit-scrollbar) {
    width: 6px;
}

:deep(.el-select.is-multiple .el-select__tags::-webkit-scrollbar-track) {
    background: transparent;
}

:deep(.el-select.is-multiple .el-select__tags::-webkit-scrollbar-thumb) {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
}

:deep(.el-select.is-multiple .el-select__tags::-webkit-scrollbar-thumb:hover) {
    background: rgba(0, 0, 0, 0.3);
}

:deep(.el-select .el-tag) {
    background-color: #f8f8f8;
    color: #000;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    margin: 0;
    padding: 4px 8px;
    font-size: 14px;
    font-weight: 500;
}


/* Ensure caret and clear icons align nicely */
:deep(.el-select:not(.is-multiple) .el-input__suffix) {
    height: 48px;
}

:deep(.el-select.is-multiple .el-input__suffix) {
    height: auto;
}

/* Dropdown menu shadow/rounding */
:deep(.el-select-dropdown) {
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
}

/* Menu item selected check color */
:deep(.el-select-dropdown__item.selected) {
    color: #111827;
}

/* Match font size and vertical centering */
:deep(.el-select:not(.is-multiple) .el-input__inner) {
    line-height: 48px;
}

/* Option item with avatar */

.el-select__tags {
    height: 100%;
    overflow: overlay;
}
.option-item {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.option-avatar img {
    border-radius: 50%;
    object-fit: cover;
    display: block;
}
</style>
